// Bridges legacy theme.js add-to-cart (ajaxProduct:added) to the
// <cart-drawer-reebok> protocol (cart:build) so any standard Shopify
// product form refreshes the new drawer without per-section changes.
document.addEventListener('ajaxProduct:added', () => {
  document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:open',  { bubbles: true }));
});
